export default {
  "name": "NCTree",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCTree",
  "label": "树",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "treeType": {
        "title": "区域编码",
        "description": "区域编码",
        "enumNames": [
          "同步树",
          "异步树"
        ],
        "type": "enum",
        "enum": [
          "syncTree",
          "asyncTree"
        ],
        "default": "syncTree"
      },
      "focusable": {
        "title": "是否可以使用tab聚焦",
        "description": "是否可以使用tab聚焦",
        "type": "boolean",
        "default": true
      },
      "needEdit": {
        "title": "是否需要编辑树",
        "description": "是否需要编辑树",
        "type": "boolean",
        "default": true
      },
      "needSearch": {
        "title": "是否需要搜索",
        "description": "是否需要搜索",
        "type": "boolean",
        "default": true
      },
      "defaultExpandAll": {
        "title": "默认展开全部",
        "description": "默认展开全部",
        "type": "boolean",
        "default": false
      },
      "checkable": {
        "title": "是否可勾选",
        "description": "是否可勾选",
        "type": "boolean",
        "default": false
      },
      "showModal": {
        "title": "是否显示编辑弹框",
        "description": "是否显示编辑弹框",
        "type": "boolean",
        "default": true
      },
      "hiddenDefaultIcon": {
        "title": "隐藏默认的文件夹图标",
        "description": "隐藏默认的文件夹图标",
        "type": "boolean",
        "default": false
      },
      "mustExpandable": {
        "title": "禁用时是否禁用展开",
        "description": "禁用时是否禁用展开",
        "type": "boolean",
        "default": false
      },
      "metaId": {
        "title": "编辑树节点表单的模板id",
        "description": "编辑树节点表单的模板id",
        "type": "string"
      },
      "showLine": {
        "title": "显示连接线",
        "description": "显示连接线",
        "type": "boolean"
      },
      "checkStrictly": {
        "title": "父子节点勾选是否关联",
        "description": "父子节点勾选是否关联",
        "type": "boolean",
        "default": true
      },
      "selectedForInit": {
        "title": "是否进行初始化选中操作",
        "description": "是否进行初始化选中操作",
        "type": "boolean",
        "default": false
      },
      "searchType": {
        "title": "搜索模式",
        "description": "搜索模式",
        "enumNames": [
          "定位",
          "过滤"
        ],
        "type": "enum",
        "enum": [
          "location",
          "filtration"
        ],
        "default": "location"
      },
      "addModalTitle": {
        "title": "新增弹框标题",
        "description": "新增弹框标题",
        "type": "string"
      },
      "editModalTitle": {
        "title": "编辑弹框标题",
        "description": "编辑弹框标题",
        "type": "string"
      },
      "delModalTitle": {
        "title": "删除弹框标题",
        "description": "删除弹框标题",
        "type": "string"
      },
      "switcherClass": {
        "title": "开关的className",
        "description": "开关的className",
        "type": "string"
      },
      "tooltipField": {
        "title": "tooltip中展示的字段",
        "description": "tooltip中展示的字段",
        "type": "string"
      },
      "lazyLoad": {
        "title": "是否滚动加载",
        "description": "是否滚动加载",
        "type": "boolean",
        "default": false
      },
      "searchWhenValueChange": {
        "title": "搜素值改变时触发查询",
        "description": "搜素值改变时触发查询",
        "type": "boolean",
        "default": true
      },
      "noCheckWhenSelect": {
        "title": "点击文本不勾选节点",
        "description": "点击文本不勾选节点",
        "type": "boolean",
        "default": false
      },
      "triggerCheckWhenSelect": {
        "title": "点击文本时触发选中回调",
        "description": "点击文本时触发选中回调",
        "type": "boolean",
        "default": false
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}